<div class="auth-page">
  <div class="auth-wrapper">
    <div class="auth-brand">
      <img src="logo.svg" alt="Every Rupee Spent logo" width="28" height="28" />
      <span>Every Rupee Spent</span>
    </div>
    <mat-card class="auth-card">
      <mat-card-header>
        <mat-card-title>Create your account</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Your name</mat-label>
            <input matInput formControlName="name" />
            @if (form.controls.name.invalid) {
              <mat-error>Name is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email" />
            @if (form.controls.email.hasError('required')) {
              <mat-error>Email is required</mat-error>
            } @else if (form.controls.email.hasError('email')) {
              <mat-error>Enter a valid email address</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" autocomplete="new-password" />
            @if (form.controls.password.hasError('required')) {
              <mat-error>Password is required</mat-error>
            } @else if (form.controls.password.hasError('minlength')) {
              <mat-error>Password must be at least 8 characters</mat-error>
            } @else {
              <mat-hint>At least 8 characters</mat-hint>
            }
          </mat-form-field>

          <div class="country-field" role="radiogroup" aria-describedby="country-hint">
            <span class="country-label">Country</span>
            <mat-radio-group formControlName="country">
              @for (option of countryOptions; track option.value) {
                <mat-radio-button [value]="option.value">{{ option.label }}</mat-radio-button>
              }
            </mat-radio-group>
            <p id="country-hint" class="country-hint">Sets your default categories and pricing currency.</p>
            @if (form.controls.country.invalid && form.controls.country.touched) {
              <p class="error-message">Please select a country</p>
            }
          </div>

          @if (errorMessage(); as msg) {
            <p class="error-message">{{ msg }}</p>
          }

          <button mat-flat-button color="primary" type="submit" class="full-width" [disabled]="loading()">
            @if (loading()) {
              <mat-spinner diameter="20" />
            } @else {
              Register
            }
          </button>
        </form>
      </mat-card-content>
      <mat-card-footer class="auth-footer">
        <a routerLink="/login">Already have an account? Log in</a>
      </mat-card-footer>
    </mat-card>
    <footer class="page-footer">© {{ currentYear }} everyrupeespent.com</footer>
  </div>
</div>
